export default {
  isOverviewChartShown: 'Übersichtsdiagramm anzeigen',
  isZoomedChartShown: 'Auf Toleranzband gezoomtes Diagramm anzeigen',
  isSectionsTableShown: 'Tabelle der Abschnitte anzeigen',
};
